import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RequestStatus } from '@patient-ui/shared/enums';

import {
  OrbiHistoryState,
  orbiHistoryFeatureKey,
} from './orbi-history.reducer';

export const selectOrbiHistoryState = createFeatureSelector<OrbiHistoryState>(
  orbiHistoryFeatureKey
);

export const selectOrbiHistoryConversations = createSelector(
  selectOrbiHistoryState,
  (state) => state.conversations
);

export const selectOrbiHistoryLoadStatus = createSelector(
  selectOrbiHistoryState,
  (state) => state.loadStatus
);

export const selectOrbiHistoryReachedEnd = createSelector(
  selectOrbiHistoryState,
  (state) => state.reachedEnd
);

export const selectOrbiHistoryError = createSelector(
  selectOrbiHistoryState,
  (state) => state.error
);

/** True while a history page request is in flight (drives the loader). */
export const selectOrbiHistoryLoading = createSelector(
  selectOrbiHistoryLoadStatus,
  (status) => status === RequestStatus.Pending
);

/** True when there are more pages to load (not loading + not at the end). */
export const selectOrbiHistoryCanLoadMore = createSelector(
  selectOrbiHistoryLoadStatus,
  selectOrbiHistoryReachedEnd,
  (status, reachedEnd) => status !== RequestStatus.Pending && !reachedEnd
);

export const orbiHistoryQuery = {
  selectOrbiHistoryState,
  selectOrbiHistoryConversations,
  selectOrbiHistoryLoadStatus,
  selectOrbiHistoryReachedEnd,
  selectOrbiHistoryError,
  selectOrbiHistoryLoading,
  selectOrbiHistoryCanLoadMore,
};
